import stbAPIGateway from '../../../../services/stbAPIGateway';

export const patchClientStudentManagementConfig = async (
  { rootGetters },
  { clientSid, payload }
) => {
  const axios = rootGetters['app/stbAxios'];
  const apiUrl = process.env.API_URL || '';
  const stbApi = stbAPIGateway(axios, apiUrl);
  const response = await stbApi.patchClientStudentManagementConfig(clientSid, payload);
  return response;
};
